var minimumNumberOfStreams = 1000;
var maximumNumberOfStreams = 100000;
var defaultNumberOfStreams = 50000;
export { defaultNumberOfStreams, maximumNumberOfStreams, minimumNumberOfStreams };